import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=1c792a9e&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c792a9e')) {
      api.createRecord('1c792a9e', component.options)
    } else {
      api.reload('1c792a9e', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=1c792a9e&", function () {
      api.rerender('1c792a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UT8zmvZV9qr1/JS/ImageCarousel.vue"
export default component.exports